<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">お見積もり内容の確認</span>
              <span class="breadcrumb-link current">お申し込み内容の確認</span>
              <span class="breadcrumb-link">ご契約申し込み完了</span>
            </div>
            <h1 class="hdg02">お申し込み内容の確認</h1>
          </div>

          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">下記内容をご確認いただき、「契約を申し込む」ボタンを押下して申し込みを確定してください。</p>
              <h2 class="hdg03">お申し込み内容</h2>
              <a :href="'/lc/app/public/print/estimate-print?token=' + group1.token" target="_blank" class="estimate-print txt-blue">お見積もり印刷画面を表示 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
              <div class="purchase-summary">
                <p class="purchase-summary-heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ group1.totalFeeDisp }}</strong>円（税込）</p>
              </div>

              <div v-for="(item, index) in group1.packageLists" :key="'package_' + index" class="purchase-detail">
                <div class="purchase-detail-heading">
                  <h2 class="hdg03">{{ item.package_name }}</h2>
                  <p class="purchase-detail-heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ item.sub_total_fee }}</strong>円（税込）</p>
                </div>
                <div class="purchase-detail-content">

                  <div class="tbl01 purchase-detail-table">

                    <!-- PCの場合 -->
                    <table class="tbl visible-pc">
                      <colgroup>
                        <col style="width:30%;">
                        <col style="width:15%;">
                        <col style="width:30%;">
                        <col style="width:25%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th class="ta-center">ライセンス数</th>
                          <th class="ta-center">ライセンス期間</th>
                          <th class="ta-center">価格（税込）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item2, index2) in item.basic_products" :key="'package_' + index + '_option_product0_' + index2">
                          <th>{{ item2.name }}</th>
                          <td class="ta-center">{{ item2.license_number }}</td>
                          <td class="ta-center">12カ月<br>（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</td>
                          <td class="ta-center">基本契約　{{ item2.basic_price }}円<br>追加ライセンス　{{ item2.add_price }}円</td>
                        </tr>
                        <tr v-for="(item2, index2) in item.option_products" :key="'package_' + index + '_option_product1_' + index2">
                          <th class="pl40">{{ item2.name }}</th>
                          <td class="ta-center">{{ item2.license_number }}</td>
                          <td class="ta-center">12カ月<br>（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</td>
                          <td class="ta-center">基本契約　{{ item2.basic_price }}円<br>追加ライセンス　{{ item2.add_price }}円</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- SPの場合 -->
                    <table class="tbl visible-sp">
                      <tbody>
                        <template v-for="(item2, index2) in item.basic_products">
                          <tr :key="'package_' + index + '_basic_product0_0_' + index2">
                            <th>見積もりライセンス</th>
                            <td>{{ item2.name }}</td>
                          </tr>
                          <tr :key="'package_' + index + '_basic_product0_1_' + index2">
                            <th>見積もりライセンス数</th>
                            <td>{{ item2.license_number }}</td>
                          </tr>
                          <tr :key="'package_' + index + '_basic_product0_2_' + index2">
                            <th>ライセンス期間</th>
                            <td>12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</td>
                          </tr>
                          <tr :key="'package_' + index + '_basic_product0_3_' + index2">
                            <th>価格（税込）</th>
                            <td>基本契約　{{ item2.basic_price }}円<br>追加ライセンス　{{ item2.add_price }}円</td>
                          </tr>
                        </template>
                        <template v-for="(item2, index2) in item.option_products">
                          <tr :key="'package_' + index + '_basic_product1_0_' + index2">
                            <th>見積もりライセンス</th>
                            <td>{{ item2.name }}</td>
                          </tr>
                          <tr :key="'package_' + index + '_basic_product1_1_' + index2">
                            <th>見積もりライセンス数</th>
                            <td>{{ item2.license_number }}</td>
                          </tr>
                          <tr :key="'package_' + index + '_basic_product1_2_' + index2">
                            <th>ライセンス期間</th>
                            <td>12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</td>
                          </tr>
                          <tr :key="'package_' + index + '_basic_product1_3_' + index2">
                            <th>価格（税込）</th>
                            <td>基本契約　{{ item2.basic_price }}円<br>追加ライセンス　{{ item2.add_price }}円</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              <h2 class="hdg03 mt60">お支払い方法</h2>
              <div class="contract-content-payment">
                <p class="txt">{{ group1.paymentName }}</p>
              </div>

              <div class="contact-submit">
                <router-link to="/public/estimate-final/index" class="contact-submit-link">
                  <FontawesomeIcon :icon="['fas','angle-left']" class="icn" />
                  戻る
                </router-link>
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.submitForConfirm">契約を申し込む</button>
                </div>
              </div>
              <EstimateFinalContactInformation />
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import EstimateFinalContactInformation from '@/components/public/estimate-final/partial/EstimateFinalContactInformation.vue'
import * as logicEstimateFinal from '@/logic/public/EstimateFinal'

export default defineComponent({
  components: {
    EstimateFinalContactInformation
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicEstimateFinal.getGroupConfirm(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
h2.hdg03 {
  display: inline-block;
} 
.estimate-print {
  margin-left: 40px;
}
.estimate-print

.contact-container {
  display: block;
}
.responsive .purchase-detail-table .tbl{
  tbody td{
    border-top: 1px solid #ddd;
  }
}
</style>
